import React, { useEffect } from 'react'
import { Box, Button, Flex, Text, useColorMode } from 'theme-ui'

const ZinePage = () => {
  const [, setColorMode] = useColorMode()

  useEffect(() => {
    setColorMode('club-house')
  }, [setColorMode])

  return (
    <Box
      data-builder-component="page"
      data-name="zine-page"
      data-builder-model="page"
      sx={{ mt: '3rem' }}
    >
      <Flex
        sx={{
          color: 'tertiary',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          my: '3rem',
        }}
      >
        <Text
          sx={{
            fontWeight: 900,
            fontSize: [30, '40px', '50px'],
            px: ['16px', '24px'],
            mb: '1rem',
          }}
        >
          START BY SHARING IT
        </Text>
        <Text
          sx={{
            fontSize: ['16px', '18px', '20px'],
            fontWeight: 500,
            textAlign: 'center',
            maxWidth: '1200px',
            px: ['16px', '24px'],
          }}
        >
          Here’s a black and white version of STIR IT UP that you can print on
          any printer and share with anybody looking to start something. New
          ideas have no internal momentum at the start. They need a small team
          of brave, oddly-wired, passionate people to pedal frenetically in the
          same direction. Maybe you know some people like that. Maybe you’re one
          of them. If so, print this. Share it. Start something. We can&apos;t
          wait to see it. (Want to see what we started? Check it out here!)
        </Text>
      </Flex>
      <Flex
        sx={{
          position: 'relative',
          flexDirection: 'column',
          alignItems: 'center',
          height: '100%',
          width: '100vw',
          my: '3rem',
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: '1200px',
            minHeight: 'auto',
            px: ['16px', '24px'],
            pb: '24px',
          }}
        >
          <Flex
            sx={{
              position: 'sticky',
              top: 0,
              zIndex: 20,
              width: '100%',
              justifyContent: 'center',
              alignItems: 'center',
              py: '12px',
              px: '12px',
              mb: '16px',
              borderRadius: '14px',
              backdropFilter: 'blur(8px)',
              backgroundColor: 'transparent',
              color: 'tertiary',
              fontFamily: 'heading',
            }}
          >
            <Button
              data-builder-component="button"
              data-name="zine-download-button"
              variant="rounded"
              sx={{
                fontSize: '18px',
                px: '16px',
                py: '12px',
                backgroundColor: 'tertiary',
                color: 'secondary',
                fontFamily: 'heading',
                minWidth: '200px',
              }}
              as="a"
              href="/260302_Rudy_Goodles_Zine_Digital_BW_01.pdf"
              download="260302_Rudy_Goodles_Zine_Digital_BW_01.pdf"
              type="application/pdf"
            >
              Download
            </Button>
          </Flex>
        </Box>
      </Flex>
    </Box>
  )
}

export default ZinePage
